import { ComponentType } from "react";

import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { LiteListFrameGeneralAttributeProps } from "../../../../LiteListFrameGeneralAttribute";
import { LiteListFrameLinkAttribute } from "../../../../LiteListFrameLinkAttribute";
import { LLFAbstractRenderer } from "./LLFAbstractRenderer";

export class LLFLinkAttributeRenderer extends LLFAbstractRenderer {
    private readonly _controlString: string = "LinkAttribute";

    public canRender(element: HTMLElement): boolean {
        return element.getAttribute("data-tscitem") === this._controlString;
    }

    public override getAttributes(element: HTMLElement, ...args: unknown[]): readonly IDataSourceAttribute[] {
        return super.getAttributes(element, args).map(attr => ({ ...attr, trimValue: false }));
    }

    public override get component(): ComponentType<LiteListFrameGeneralAttributeProps> {
        return LiteListFrameLinkAttribute;
    }
}
